import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
const getters = {
  episodesProgress: state => state.episodesProgress,
  episodeProgressByUuid: state => uuid => state.episodesProgress[uuid],
  // libraryEpisodes: state => state.libraryEpisodes,
};

const mutations = {
  setAllEpisodesProgress: (state, episodes) => {
    episodes.forEach((episode) => {
      Vue.set(state.episodesProgress, episode.episode_uuid, episode);
    });
  },
  setEpisodeProgressById: (state, episodeProgress) => {
    if (state.episodesProgress[episodeProgress.episode_uuid]) {
      state.episodesProgress[episodeProgress.episode_uuid] = episodeProgress;
    } else {
      Vue.set(state.episodesProgress, episodeProgress.episode_uuid, episodeProgress);
    }
  },
  clearAllEpisodesProgress: (state) => {
    state.episodesProgress = {};
  },
};

const state = {
  episodesProgress: {},
};

const actions = {
  setAllEpisodesProgress: (context, episodes) => {
    context.commit('setAllEpisodesProgress', episodes);
  },
  setEpisodeProgressById: (context, episodeProgress) => {
    context.commit('setEpisodeProgressById', episodeProgress);
  },
  clearAllEpisodesProgress: (context) => {
    context.commit('clearAllEpisodesProgress');
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./app/src/store/modules/episodes.js